// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
import { WmsRequest } from '../serviceControl';
/**
   * The LayerInfo class searches info about layers
   */
export class LayerInfo {
    /**
     * It makes a call getCapabilities to a WmsService and it returns
     * a xml we go throught it in search of the coords, we transform
     * them to bounds
     * @returns A promise that resolves to a LatLngBounds object.
     */
    static async getBounds(overlayLayer) {
        const capabilities = await WmsRequest.getCapabilities(overlayLayer.url);
        const firstKey = Object.keys(capabilities)[0];
        const layers = capabilities[firstKey].Capability.Layer.Layer;
        // Layers in server
        let layersToSearch = [];
        if (!Array.isArray(layers)) {
            layersToSearch.push(layers);
        }
        else {
            layersToSearch = layers;
        }
        let bounds;
        if (layers !== undefined) {
            overlayLayer.layers.forEach((l) => {
                const boundingBox = layersToSearch.filter((layer) => (layer.Name
                    ? l.layer.includes(layer.Name['#text'])
                    : layer.Layer.find((serverLayer) => l.layer.includes(serverLayer.Name['#text'])) !== null))[0];
                const bboxFiltered = boundingBox
                    ? boundingBox.EX_GeographicBoundingBox
                    : null;
                if (bboxFiltered) {
                    const southWest = L.latLng(bboxFiltered.southBoundLatitude['#text'], bboxFiltered.westBoundLongitude['#text']);
                    const northEast = L.latLng(bboxFiltered.northBoundLatitude['#text'], bboxFiltered.eastBoundLongitude['#text']);
                    const layerBounds = L.latLngBounds(southWest, northEast);
                    if (!bounds) {
                        bounds = layerBounds;
                    }
                    else {
                        // Extend current bounds to include current ones
                        bounds = bounds.extend(layerBounds);
                    }
                }
            });
        }
        // Return null if no bounding box has been obtained
        if (!bounds)
            return null;
        return bounds;
    }
}
//# sourceMappingURL=layerInfo.js.map